import { IRequiredPermission } from 'bookraw/shared/services/navigation.service';
import { AvailableFeatures } from 'bookraw/shared/models/feature.model';
import { environment } from 'env/environment';

interface PageInfo {
  /** A címsorban megjelenő szöveg */
  title: string;
  /** A breadcrumbban megjelenő szöveg, alapesetben a title */
  breadcrumb?: string;
  /** A menüben megjelenő szöveg, alapesetben a title */
  menuTitle?: string;
  /** A menü listájába hanyadik elemként legyen beszúrva (a nem látszódó menüpontok is beleszámítanak) */
  menuOrder?: number;
  /** Angular Material ikon */
  matIcon?: string;
  /** SVG ikon fájlnév (menu_icons mappa) */
  svgIcon?: string;
  /** A menüpont megjelenítéséhez szükséges jogosultság */
  requiredPermission?: IRequiredPermission
  /** A menüpont megjelenítése különböző projektekben való tiltása */
  requiredFeature?: AvailableFeatures;
}

interface ExternalPageInfo extends PageInfo {
  /** A külső URL, amit megnyitunk a menüpontra kattintáskor */
  externalUrl: string;
}

export interface InternalPageInfo extends PageInfo {
  /** Relatív URL, amin elérhető az oldal */
  url: string;
  /** A belső oldal HTML tartalma */
  htmlContent: string;
}

export function isExternal(pageInfo: PageInfo): pageInfo is ExternalPageInfo {
  return !!pageInfo['externalUrl'];
}

export const customPages: Array<ExternalPageInfo | InternalPageInfo> = [
  {
    url: 'book-reading-report',
    title: 'menu.book_reading_report',
    svgIcon: 'statistics',
    menuOrder: 10, // weekly-report és statistics közé
    htmlContent: `
      <div id="rs-root"></div>
      <script
      src="${environment.bookrReadingUrl}"
      data-target="#rs-root"
      ></script>
    `,
    requiredPermission: {
      action: 'user_view',
      params: ['child'],
      onlyAdmin: false
    }
  },
  {
    url: 'bahasa-statistics',
    title: 'menu.bahasa_statistics',
    svgIcon: 'bahasa',
    menuOrder: 11, // book-reading-report és statistics közé
    htmlContent: `
      <div id="sasbadi-root"></div>
      <script
      src="${environment.bahasaStatisticsUrl}"
      data-target="#sasbadi-root"
      ></script>
    `,
    requiredPermission: {
      action: 'sasbadi_view',
    }
  },
  {
    url: 'resources',
    title: 'menu.resources',
    svgIcon: 'documents',
    menuOrder: 24, // Songs and Karaoke és a Support AI közé
    htmlContent: `
      <div id="app"></div>
      <link href="https://docs.bookrclass.com/css/chunk-vendors.css" rel="stylesheet" />
      <link href="https://docs.bookrclass.com/css/app.css" rel="stylesheet" />
      <script src="https://docs.bookrclass.com/js/chunk-vendors.js" defer></script>
      <script src="https://docs.bookrclass.com/js/app.js" defer></script>
    `,
    requiredPermission: {
      action: 'user_view',
      params: ['child'],
      except: ['whiteLabelTeacher'],
    },
    requiredFeature: 'resources'
  },
  {
    url: 'speaking-studio',
    title: 'menu.speaking_studio',
    matIcon: 'record_voice_over',
    menuOrder: 25, // Resources és a Support AI közé
    htmlContent: `
      <div id="ai-speaking-studio-root"></div>
      <script
      src="https://ai-speaking-studio-standalone.bookrnext.com/loader.js"
      data-target="#ai-speaking-studio-root"
      ></script>
    `,
    requiredPermission: {
      action: 'user_view',
      params: ['child'],
      onlyAdmin: false
    },
    requiredFeature: 'next'
  },
  {
    title: 'menu.help_center',
    externalUrl: 'https://bookrclass.com/help-center/',
    svgIcon: 'question',
    requiredPermission: {
      action: 'user_view',
      except: ['ssoPartner', 'whiteLabelTeacher']
    }
  }
];
